import { KeyIcon, PaperPlaneTiltIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { SmartActionButton } from '@/components/ui/smart-action-button'

import { useAccountEmailActions } from './use-account-email-actions'

interface AccountEmailsMenuProps {
  disabled?: boolean
  email: string
}

export const AccountEmailsMenu = ({ disabled, email }: AccountEmailsMenuProps) => {
  const { t } = useTranslation(['organisation'])
  const {
    handleSendPasswordReset,
    handleSendSetupLink,
    isSendingPasswordReset,
    isSendingSetupLink,
  } = useAccountEmailActions()

  return (
    <SmartActionButton
      disabled={disabled}
      items={[
        {
          icon: PaperPlaneTiltIcon,
          label: t('organisation:shared.accountEmails.sendSetupLink'),
          loading: isSendingSetupLink,
          onClick: () => handleSendSetupLink(email),
        },
        {
          icon: KeyIcon,
          label: t('organisation:shared.accountEmails.sendPasswordReset'),
          loading: isSendingPasswordReset,
          onClick: () => handleSendPasswordReset(email),
        },
      ]}
      label={t('organisation:shared.accountEmails.menuLabel')}
      size="small"
    />
  )
}
